import React, { createContext, useContext } from "react";
import useFirebaseData from "../hooks/useFirebaseData"; 
import { database } from "../configuration";
const FirebaseDatabaseRootDataContext = createContext({
  rootData: null,
  rootDataLoading: true,
  rootDataError: null,
});

export const useFirebaseDatabaseRootData = () => {
  return useContext(FirebaseDatabaseRootDataContext);
};


export const FirebaseDatabaseRootDataProvider = ({ children }) => {
  const { data, loading, error } = useFirebaseData(database, "/");

  const contextValue = {
    rootData: data,
    rootDataLoading: loading,
    rootDataError: error,
  };

  return (
    <FirebaseDatabaseRootDataContext.Provider value={contextValue}>
      {children}
    </FirebaseDatabaseRootDataContext.Provider>
  );
};